const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/patientsActions.ts';
import { KISAPI as API } from '../middleware/kisapi';
import { KisApiAction, kisapiActionTypes } from '../defs/actionTypes';
import {
    apiDeletePatientImage,
    apiLoad1Patient,
    apiLoadPatientImage,
    apiUploadPatientImage,
} from '@cistec/common_web/actions/kisapi/patients';

export const atSetCurrentPatNr = 'COMMON_SET_CURRENT_PATNR';
export const atSetCurrentPatNrFallNr = 'COMMON_SET_PATNR_FALLNR';

export const LOAD_PATIENT = kisapiActionTypes('LOAD_PATIENT');
export const LOAD_PATIENT_PICTURE = kisapiActionTypes('LOAD_PATIENT_PICTURE');
export const UPLOAD_PATIENT_PICTURE = kisapiActionTypes('UPLOAD_PATIENT_PICTURE');
export const DELETE_PATIENT_PICTURE = kisapiActionTypes('DELETE_PATIENT_PICTURE');

/**
 * Loads a single patient record.
 * @param patnr patient id
 * @param withStdAndSpecRec true=also fetch the Mandate-specific record
 * @param fullRecord true=fetch the full record rather than a partial record with the most common data
 * @param caseId fallnr; if specified, we also load the Bezugspersonen
 * @param withExtras true=also pass back derived data such as the patient's age in human-readable form
 */
export function getPatient(
    patnr: string,
    withStdAndSpecRec: boolean = false,
    fullRecord: boolean = false,
    caseId: string | undefined = undefined,
    withExtras: boolean = false
) {
    return {
        type: LOAD_PATIENT.combined,
        [API]: apiLoad1Patient(patnr, withStdAndSpecRec, caseId, withExtras),
        meta: { patnr, withStdAndSpecRec, fullRecord, caseId, withExtras },
    };
}

export type IGetPatientAction = KisApiAction<typeof getPatient>;

export function setCurrentPatient(patnr: string | undefined) {
    return {
        type: atSetCurrentPatNr,
        payload: patnr,
    };
}

export type SetCurrentPatNrAction = ReturnType<typeof setCurrentPatient>;

/**
 * Prefer this action over setting patnr and fallnr with two separate actions, because doing the latter can cause sagas
 * reacting to the intermediate state.
 */
export function actionSetCurrentPatNrFallNr(patnr: string, fallnr: string | undefined) {
    if (!patnr) {
        // We need the patnr, because the casesReducer stores the cases per patient!
        throw new Error('actionSetCurrentPatNrFallNr called with no patnr');
    }
    return {
        type: atSetCurrentPatNrFallNr,
        patnr,
        fallnr,
    };
}

export type SetCurrentPatNrFallNrAction = ReturnType<typeof actionSetCurrentPatNrFallNr>;

export function loadPatientPicture(patnr: string, callerId?: string) {
    return {
        type: LOAD_PATIENT_PICTURE.combined,
        [API]: apiLoadPatientImage(patnr),
        meta: { patnr, callerId },
    };
}

export type ILoadPatientPictureAction = KisApiAction<typeof loadPatientPicture>;

export function uploadPatientPicture(patnr: string, imageData: string, imageFormat: string, callerId?: string) {
    return {
        type: UPLOAD_PATIENT_PICTURE.combined,
        [API]: apiUploadPatientImage(patnr, imageData, imageFormat),
        meta: { patnr, imageData, imageFormat, callerId },
    };
}

export type UploadPatientPictureAction = KisApiAction<typeof uploadPatientPicture>;

export function deletePatientPicture(patnr: string, callerId?: string) {
    return {
        type: DELETE_PATIENT_PICTURE.combined,
        [API]: apiDeletePatientImage(patnr),
        meta: { patnr, callerId },
    };
}

export type DeletePatientPictureAction = KisApiAction<typeof deletePatientPicture>;
